// drinkpoppi.com replica brand palette — exact values measured from the live
// site. SCSS twin: styles/colors.scss (keep in sync). Near-duplicate hexes
// elsewhere in the app are distinct captured values — never merge them.
export const colors = {
  magenta: "#ec008c",
  yellow: "#fff200",
  lime: "#e5fc0f",
  retailerLime: "#e3f205",
  pink: "#ffc7df",
  red: "#ee1420",
  cyan: "#00aeef",
  purple: "#440099",
  blue: "#008cf1",
  orange: "#eb5600",
  cream: "#ffebb3",
} as const;
